import React, { useState, useEffect, useRef } from "react";
import styles from "./notification.module.css";
import IMAGES from "../../assets/images/images";
import { formatDate } from "../../utils/arrayUtils";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "../../components/dropDown/Notificationdropdown";
import clock from "../../assets/images/clock.svg"
import InfiniteScroll from "react-infinite-scroll-component";
import { Loader } from "../../components/loader/Loader";
import { DETAILS_PAGENAME_CONSTANT, EVENT_CONSTANTS, mapNotificationRoute, MODULE_LABELS_CUSTOMER,MODULE_LABELS_INTERNAL } from "../../utils/constants/notificationConstants";
import { UserManagementTab } from "../../utils/constants/userManagementConstant";
import { USER_TYPE } from "../../utils/constants/userConstants";
import SecondaryTooltip from "../../components/secondaryToolTip/secondaryToolTip";

const Reminder = React.forwardRef((props, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const overlayRef = useRef(null);
  let timer = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(timer.current); 
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timer.current = setTimeout(() => {
      setIsOpen(false);
    }, 700);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timer.current); 
    };
  }, []);

  React.useImperativeHandle(ref, () => ({
    handleMouseEnter,
  }));

  const handlereminder = (data) => { 
    setIsOpen(false);
    const payload = {
      docId: props.data.id,
      reminderHours: data
    };
    
    props.RemindMe(payload)
      .then((result) => {
        if (result.status) {
             props.getEventNotificationList(null,props?.dropDownOption);
        } else {
          // Handle failure
        }
      })
      .catch((error) => {
        // Handle error
      });

  };

  const reminderdata = [
    {
      time: "Remind me Tomorrow",
      value:"24"
    },
    {
      time: "Remind me in 3 Hours",
      value:"3"
    },
  ];

  return (
    <div
      ref={overlayRef}
      className={styles.mainreminder}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className={styles.userIcon}>
        <img className={styles.clockIcon} src={props.isReminder ? IMAGES.clock :IMAGES.clockblack } alt="notification" />
      </div>

      {isOpen && (
        <div className={styles.reminderInnerbox}>
          {reminderdata.map((data, index) => (
            <div
              className={styles.reminderoption}
              onClick={() => handlereminder(data.value)}
              key={index}
            >
              {data.time}
            </div>
          ))}
        </div>
      )}
    </div>
  );
});


const Notification = React.forwardRef((props, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isactive, setActive] = useState(false);
  const overlayRef = useRef(null);
  const [isReadDisabled, setReadDisabled] = useState(false)
  const handleClick = () => {
    setIsOpen(!isOpen);
    setActive(!isactive)
  };

  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
      setIsOpen(false);
      setActive(false)
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  React.useImperativeHandle(ref, () => ({
    handleClick,
  }));

  let count = props?.dropdownOptions?.data?.length > 0 ? props.dropdownOptions.data[0].count : 0;

  const [selectedOption, setSelectedOption] = useState(() => {
    return props.dropdownOptions?.data?.length > 0 ? props.dropdownOptions.data[0] : null;
    });

    useEffect(() => {
      if (props.dropdownOptions?.data?.length > 0) {
        const updatedSelectedOption = props.dropdownOptions.data?.find(
          (opt) => opt.label === selectedOption?.label
        );
       if (updatedSelectedOption) {
          setSelectedOption(updatedSelectedOption);
        }
      }
    }, [props.dropdownOptions]);
    
  
  const dropDownOption = selectedOption?.value;
  
    useEffect(() => { 
      props.NotificationOptions();
    }, []);
  
    // useEffect(() => {
    //   if (props.dropdownOptions.data && props.dropdownOptions.data.length > 0) {
    //     setSelectedOption(props.dropdownOptions.data[0]);
    //   }
    // }, [props.dropdownOptions]);
  
    useEffect(() => {
      if(selectedOption){
        props.getEventNotificationList(null, selectedOption?.value);
      }
    }, [selectedOption]);

    useEffect(()=>{
      if (props.dropdownOptions.data && props.dropdownOptions.data.length > 0) {
        setSelectedOption(props.dropdownOptions.data[0]);
      }
      props.getEventNotificationList(null, selectedOption?.value);
    },[isOpen])
  
    const handleChange = (option) => {
      setSelectedOption(option);
    };
  
  const navigate = useNavigate();
  const goToServiceDetails = (requestId, detailType,userType) => {
    switch (detailType) {
      case "DEMANDS":
        navigate(`/connectivity/demandDetail/${requestId}`);
        break;
      case "DEMAND_TO_CASH":
        navigate(`/connectivity/demandToCashDetail/${requestId}`);
        break;
      case "INCIDENT":
        navigate(`/incident-management/incidentDetail/${requestId}`);
        break;
      case "SERVICE_REQUEST":
        navigate(`/incident-management/serviceRequestDetail/${requestId}`);
        break;
      case "CUSTOMER_ONBOARDING":
        navigate(`/user-management/OnboardingRequestDetail/${requestId}`);
        break;
      case "CUSTOMER_ONBOARDING_APPROVAL":
        navigate(`/user-management/OnboardingDetail/${requestId}`);
        break;
      case "CUSTOMER_DETAILS":
        navigate(`/user-management/customerdetail/${requestId}`);
        break;
      case "VF_INTERNAL_LIST":
        navigate(`/user-management/vodafoneUsers`);
        props.setActivePrimaryTab(UserManagementTab.VF_GROUP_USER);
        break;
      default:
        console.error("Invalid detailType");
    }
  };

  const handleReadNotification = (requestId) => {
    const payload = {
      read: true,
    };
    setReadDisabled((prev) => ({ ...prev, [requestId]: true }));
    props.ReadNotification(payload, requestId)
      .then((result) => {
        if (result) {
          // Handle success
          setReadDisabled((prev) => ({ ...prev, [requestId]: false }));
           props.NotificationOptions();
           props.getModuleNotification();
           props.getEventNotificationList(null,null);
        } else {
          // Handle failure
          setReadDisabled((prev) => ({ ...prev, [requestId]: false }));
        }
      })
      .catch((error) => {
        // Handle error
        setReadDisabled((prev) => ({ ...prev, [requestId]: false }));
      });
  };

  const handleClicknotification = (data,userType) => {
    if (data) {
      // goToServiceDetails(
      //   data?.additionalInfo?.detailsId,
      //   data?.additionalInfo.detailsPageName,
      //   userType
      // );
      handleReadNotification(data.id);
      props.getEventNotificationList(null,null);
      props.NotificationOptions();
       handleClick()
    }
  };

  const goto = (data) => {
    const routeFn = mapNotificationRoute[data?.additionalInfo?.detailsPageName];
    if (!routeFn) {
      console.log("No route defined for", data?.additionalInfo?.detailsPageName);
      return "#";
    }
    return routeFn(data?.additionalInfo?.detailsId, data?.id);
  };
  
 let userType = props?.myRights?.userType

  const sortedNotifications = props?.eventnotification?.data
  

    const fetchData = () => {
      if (props.eventnotification.next) {
        props.getEventNotificationList(props.eventnotification.next,selectedOption?.value);
      }
    };
  return (
    <div ref={overlayRef}>
      <button className={styles.applybtn} onClick={handleClick}>
        <div className={styles.icon}>
          <div><img src={IMAGES.bellicon} className={`${isactive?styles.active:styles.notificationicon}`} alt="notification" /></div>
          {count !== 0 && <div className={`${styles.count} ${count > 99 && styles.moredata}`}><span>
            <SecondaryTooltip toltipalign={"notification"} text={count} positions={['bottom', 'right']}>
            {count > 99 ? '99+' : count}
            </SecondaryTooltip>
            </span></div>}
        </div>
      </button>

      {isOpen && (
        <div className={styles.overlayInnerbox}>
          <div className={styles.headerContainer}>
            <div className={styles.dropdown}>
              <Dropdown
                options={props?.dropdownOptions?.data}
                value={selectedOption}
                onChange={handleChange}
                userType={userType}
              />
            </div>
            <div className={styles.selectedcount}>Count: {selectedOption?.count}</div>
          </div>
          <div className={styles.notificationContainer} id="childScroll">
          {props.eventnotification.isLoading&&props.eventnotification.data.length !== 0&&(<Loader />)}
          {props.eventnotification.isLoading && props.eventnotification.data.length == 0 ? (
                  <Loader />
                ) : props.eventnotification.data.length == 0 ? (
                  <div className={styles.Emptydiv}>No New Notifications Found</div>
                ) : (
                  <InfiniteScroll
                    dataLength={props.eventnotification?.data?.length}
                    next={() => {
                      fetchData();
                    }}
                    hasMore={props.eventnotification.next}
                    loader={<Loader />}
                    scrollableTarget="childScroll" 
                  >
                      <div>
                      {sortedNotifications?.map((data) => (
                        <div
                          key={data?.notificationEventId}
                          className={styles.block}
                          style={{ backgroundColor: data?.read ? "#FFFFFF" : "#F9F9F9" }}               
                        >
                          <div className={styles.mainblock}>
                            <div className={styles.newmessage}>
                            {!data?.read &&  <div className={styles.new}></div>}
                            </div>
                            <div className={styles.blockinner}>
                              <div className={styles.blocktop}>
                              <div>
                                  <Link to={goto(data)} className={data.read ?styles.id :styles.idread}   onClick={() => handleClicknotification(data,userType)}>{data?.additionalInfo?.actionId ?data?.additionalInfo?.actionId :DETAILS_PAGENAME_CONSTANT[data?.additionalInfo?.detailsPageName]}</Link> 
                                  {(data?.additionalInfo?.actionId || DETAILS_PAGENAME_CONSTANT[data?.additionalInfo?.detailsPageName])&&<span className={styles.sepration}>-</span>}
                                  <span className={data.read ?styles.status:styles.statusread}>{EVENT_CONSTANTS[data.additionalInfo?.eventAction]}</span>
                                </div>
                                <div>
                               {/* <Reminder isReminder={data.isReminder} dropDownOption={dropDownOption} data={data} RemindMe={props.RemindMe} getEventNotificationList={props.getEventNotificationList}/> */}
                                </div>
                              </div>
                              <div className={`${data.read ? styles.notificationmessage : styles.notificationread} ${styles.breakline}` }>{data.message}</div>
                              <div className={styles.modulename}><div className={styles.datealign}>
                               {dropDownOption == 'all' && <div className={styles.moduletype}>{userType === USER_TYPE?.CUSTOMER ? MODULE_LABELS_CUSTOMER[data.moduleName] : MODULE_LABELS_INTERNAL[data.moduleName]} </div>}
                                <div className={styles.module}>{formatDate(data.createdAt)}</div>
                               </div>
                               {!data.read ?( !isReadDisabled[data.id]?<div className={styles.readmark} onClick={()=>handleReadNotification(data.id)}>Mark as Read</div>:<div className={styles.readmarkdisable}>Mark as Read</div>) :<></>}
                              </div>
          
                            </div>
                          </div>
                        </div>
          
                      ))}
                    </div>
                   
                  </InfiniteScroll>
                )}
                </div>
        </div>
      )}
    </div>
  );
});

export default Notification;